module.exports = __webpack_public_path__ + "static/media/playstore.401c1841.png";